import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShellComponent } from './shell.component';
import { MainMenuComponent } from '../@shared/components/main-menu/main-menu.component';
import { FeedbackComponent } from '../@shared/components/feedback/feedback.component';
import {
  NbContextMenuModule,
  NbIconModule,
  NbLayoutModule,
  NbMenuModule,
  NbSidebarModule,
  NbUserModule,
} from '@nebular/theme';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../@shared/shared.module';
import { StatusPageModule } from '../pages/status-page/status-page.module';

@NgModule({
  declarations: [ShellComponent, FeedbackComponent, MainMenuComponent],
  imports: [
    CommonModule,
    NbLayoutModule,
    NbMenuModule,
    NbIconModule,
    NbSidebarModule,
    NbContextMenuModule,
    RouterModule,
    SharedModule,
    StatusPageModule,
    NbUserModule,
  ],
})
export class ShellModule {}
